import {makeStyles} from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    // Main container
    container: {
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
        padding: '32px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        '@media (max-width: 768px)': {
            padding: '16px',
        },
    },

    // Main content card
    contentCard: {
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        padding: '32px',
        marginTop: '24px',
        '@media (max-width: 768px)': {
            padding: '16px',
            marginTop: '16px',
        },
    },
    fieldValue: {
        fontSize: '16px',
        color: '#333333',
        fontWeight: 500,
        lineHeight: '20px',
        fontFamily: 'FredokaRegular',
    },

    // Hardcoded insight tooltip
    insightTooltip: {
        backgroundColor: '#eef2ff',
        borderRadius: '10px',
        padding: '12px 16px',
        color: '#2d3a8c',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '24px',
    },
    insightTooltipLabel: {
        fontStyle: 'italic',
        color: '#4c63b6',
    },
    insightTooltipTextItalic: {
        fontSize: '16px',
        fontWeight: 500,
        fontStyle: 'italic',
        fontFamily: 'Lora',
    },
    insightTooltipText: {
        fontSize: '16px',
        fontWeight: 500,
        fontFamily: 'Lora',
    },

    // Header section
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '40px',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '16px',
        },
    },

    clientName: {
        fontSize: '36px',
        fontWeight: 600,
        color: '#333333',
        fontFamily: 'Lora',
        margin: 0,
        '@media (max-width: 768px)': {
            fontSize: '28px',
        },
    },

    actionButtons: {
        display: 'flex',
        gap: '12px',
        '@media (max-width: 768px)': {
            flexDirection: 'column',
            width: '100%',
            '& button': {
                width: '100%',
            },
        },
    },

    viewContactButton: {
        backgroundColor: 'white',
        color: '#5865f2',
        border: '1px solid #5865f2',
        borderRadius: '8px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#f8f9ff',
        },
    },

    addCaseButton: {
        backgroundColor: '#5865f2',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#4752c4',
        },
    },

    // Content sections
    section: {
        marginBottom: '40px',
    },

    sectionTitle: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#333333',
        marginBottom: '24px',
        fontFamily: 'Lora',
    },

    // Field grid layout
    fieldGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '24px',
        marginBottom: '24px',
        '@media (max-width: 768px)': {
            gridTemplateColumns: '1fr',
            gap: '16px',
        },
    },

    fieldGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    },

    fieldLabel: {
        fontSize: '18px',
        color: '#999999',
        fontWeight: 500,
        letterSpacing: '0.5px',
        fontFamily: 'Lora',
    },

    // Status indicators (moved to top right)
    statusContainer: {
        position: 'fixed',
        top: 20,
        right: 40,
        display: 'flex',
        gap: '8px',
        zIndex: 1000,
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        padding: '8px 16px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        '@media (max-width: 768px)': {
            position: 'static',
            marginBottom: '16px',
            justifyContent: 'center',
        },
    },

    // No call states
    noCallContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        textAlign: 'center',
    },

    noCallTitle: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#666666',
        marginBottom: '16px',
    },

    noCallText: {
        fontSize: '16px',
        color: '#999999',
        marginBottom: '24px',
    },

    // Hubspot button
    hubspotButton: {
        backgroundColor: '#ff6b35',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px 24px',
        fontSize: '14px',
        fontWeight: 500,
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#e55a2b',
        },
    },

    // Loading component
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        textAlign: 'center',
    },

    loadingSpinner: {
        marginBottom: '24px',
        color: '#5865f2',
    },

    loadingText: {
        fontSize: '18px',
        fontWeight: 500,
        color: '#666666',
        marginBottom: '8px',
    },

    loadingSubtext: {
        fontSize: '14px',
        color: '#999999',
    },

    // Waiting for calls component
    waitingContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '60vh',
        textAlign: 'center',
    },

    waitingIconContainer: {
        position: 'relative',
        marginBottom: '32px',
    },

    waitingSpinner: {
        color: '#5865f2',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: '-24px',
        marginLeft: '-24px',
    },

    phoneIconContainer: {
        width: '80px',
        height: '80px',
        backgroundColor: '#f0f2ff',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '8px',
    },

    phoneIcon: {
        fontSize: '32px',
        color: '#5865f2',
    },

    waitingTitle: {
        fontSize: '24px',
        fontWeight: 600,
        color: '#333333',
        marginBottom: '12px',
    },

    waitingSubtext: {
        fontSize: '16px',
        color: '#666666',
        marginBottom: '8px',
    },

    waitingDescription: {
        fontSize: '14px',
        color: '#999999',
        maxWidth: '400px',
        lineHeight: '1.5',
    },

    pulseAnimation: {
        animation: '$pulse 2s ease-in-out infinite',
    },

    '@keyframes pulse': {
        '0%': {
            transform: 'scale(1)',
            opacity: 1,
        },
        '50%': {
            transform: 'scale(1.15)',
            opacity: 0.7,
        },
        '100%': {
            transform: 'scale(1)',
            opacity: 1,
        },
    },

    // Call status indicators
    callStatusBanner: {
        backgroundColor: '#5865f2',
        color: 'white',
        padding: '16px 32px',
        marginBottom: '24px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
    },

    dialingBanner: {
        backgroundColor: '#ffa726',
    },

    connectedBanner: {
        backgroundColor: '#4caf50',
    },
}));
